import { defineMessages } from 'react-intl';

export const messages: {
	betaTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	underDevelopmentTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlassianInternalTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betaTag: {
		id: 'dtac.labs.navigationBar.betaTag',
		defaultMessage: 'Beta',
		description: 'Beta tag label for Labs app',
	},
	underDevelopmentTag: {
		id: 'dtac.assistant.navigationBar.underDevelopmentTag',
		defaultMessage: 'Under development',
		description: 'Under development tag label for Assistant app',
	},
	atlassianInternalTag: {
		id: 'dtac.graphExplorer.navigationBar.atlassianInternalTag',
		defaultMessage: 'Atlassian Internal',
		description:
			'Atlassian Internal tag label for Graph Explorer app to indicate that the app is internal to Atlassians only',
	},
});
